// src/components/Pages/Home.jsx

import React, { useState, useEffect, lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Hero from '../Hero';
import Section from '../Section';
import WishForPop from '../WishForPop/WishForPop';
import './Home.css';
import AssistedReproductionSection from '../AssistedReproduction';

const AboutSection = lazy(() => import('../Section/AboutSection'));
const Banner = lazy(() => import('../Section/BannerSection'));
const FeaturesSection = lazy(() => import('../Section/FeaturesSection'));
const TestimonialSection = lazy(() => import('../Section/TestimonialSection'));
const FaqSection = lazy(() => import('../Section/FaqSection'));
const AwardSection = lazy(() => import('../Section/AwardSection'));
const DepartmentSection = lazy(() => import('../Section/DepartmentSection'));
const ConferencesSection = lazy(() => import('../Section/AboutSection/conferences'));
const Banner2 = lazy(() => import('../Section/BannerSection/Banner2'));
const ContactMethods = lazy(() => import('../ContactMethods/ContactMethods'));

// LazySection: carga su contenido sólo al entrar en viewport
const LazySection = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const ref = React.useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref}>
      {visible ? children : <div className="section-skeleton" style={{ minHeight: '400px' }} />}
    </div>
  );
};

export default function Home() {
  const { t, i18n, ready } = useTranslation();

  const baseUrl = 'https://www.gestlifesurrogacy.com';

  const [showContactMethods, setShowContactMethods] = useState(false);

  // Check if the current locale is Australia (en-au)
  const isAustraliaLocale = i18n.language === 'en-au';

  // Set up timer to show ContactMethods after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContactMethods(true);
    }, 5000); // 10 seconds delay

    // Clean up timer if component unmounts
    return () => clearTimeout(timer);
  }, []);

//   const usePopupTrigger = () => {
//   const [shouldShow, setShouldShow] = useState(false);
//   const [hasShown, setHasShown] = useState(false);

//     useEffect(() => {
//     if (hasShown) return;

//     // Timer para mostrar después de 10 segundos
//     const timer = setTimeout(() => {
//       if (!hasShown) {
//         setShouldShow(true);
//         setHasShown(true);
//       }
//     }, 10000);

//     // Listener para scroll
//     const handleScroll = () => {
//       if (window.scrollY > 300 && !hasShown) {
//         setShouldShow(true);
//         setHasShown(true);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       clearTimeout(timer);
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, [hasShown]);

//   return { shouldShow, setShouldShow };
// };

// const WishForBabyPopup = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 9999,
//       padding: '16px'
//     }}>
//       <div style={{
//         position: 'relative',
//         backgroundColor: 'white',
//         borderRadius: '16px',
//         boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
//         maxWidth: '448px',
//         width: '100%',
//         margin: '0 16px',
//         overflow: 'hidden'
//       }}>
//         {/* Close button */}
//         <button
//           onClick={onClose}
//           style={{
//             position: 'absolute',
//             top: '16px',
//             right: '16px',
//             zIndex: 10,
//             background: 'none',
//             border: 'none',
//             color: '#6B7280',
//             cursor: 'pointer',
//             fontSize: '24px',
//             width: '32px',
//             height: '32px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }}
//         >
//           ×
//         </button>

//         {/* Background image */}
     
// {/* Opción 4: Para imagen local */}
// <div style={{
//   height: '192px',
//   backgroundImage: 'url("/images/home_1/wish-baby-bruselas.webp")', // Ruta a tu imagen local
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   backgroundRepeat: 'no-repeat',
//   position: 'relative'
// }}>
//   <div style={{
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   }}>
//             <div style={{ color: 'white', opacity: 0.2 }}>
//               <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
//                 <circle cx="60" cy="20" r="8" fill="currentColor" />
//                 <circle cx="30" cy="40" r="8" fill="currentColor" />
//                 <circle cx="90" cy="40" r="8" fill="currentColor" />
//                 <circle cx="20" cy="70" r="8" fill="currentColor" />
//                 <circle cx="60" cy="70" r="8" fill="currentColor" />
//                 <circle cx="100" cy="70" r="8" fill="currentColor" />
//                 <circle cx="40" cy="100" r="8" fill="currentColor" />
//                 <circle cx="80" cy="100" r="8" fill="currentColor" />
//                 <line x1="60" y1="20" x2="30" y2="40" stroke="currentColor" strokeWidth="2" />
//                 <line x1="60" y1="20" x2="90" y2="40" stroke="currentColor" strokeWidth="2" />
//                 <line x1="30" y1="40" x2="20" y2="70" stroke="currentColor" strokeWidth="2" />
//                 <line x1="30" y1="40" x2="60" y2="70" stroke="currentColor" strokeWidth="2" />
//                 <line x1="90" y1="40" x2="60" y2="70" stroke="currentColor" strokeWidth="2" />
//                 <line x1="90" y1="40" x2="100" y2="70" stroke="currentColor" strokeWidth="2" />
//                 <line x1="20" y1="70" x2="40" y2="100" stroke="currentColor" strokeWidth="2" />
//                 <line x1="60" y1="70" x2="40" y2="100" stroke="currentColor" strokeWidth="2" />
//                 <line x1="60" y1="70" x2="80" y2="100" stroke="currentColor" strokeWidth="2" />
//                 <line x1="100" y1="70" x2="80" y2="100" stroke="currentColor" strokeWidth="2" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         {/* Content */}
//         <div style={{ padding: '24px' }}>
//           {/* Small banner */}
//           <div style={{ textAlign: 'center', marginBottom: '16px' }}>
//             <span style={{
//               display: 'inline-block',
//               background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
//               color: 'white',
//               padding: '4px 16px',
//               borderRadius: '50px',
//               fontSize: '14px',
//               fontWeight: '500'
//             }}>
             
//               {t('bruxelles_find')}
//             </span>
//           </div>

//           {/* Main title */}
//           <h2 style={{
//             fontSize: '32px',
//             fontWeight: 'bold',
//             color: '#1F2937',
//             textAlign: 'center',
//             marginBottom: '8px'
//           }}>
//             Wish For A Baby 2025
//           </h2>

//           {/* Event details */}
//           <p style={{
//             color: '#6B7280',
//             textAlign: 'center',
//             marginBottom: '16px'
//           }}>
//             <strong>{t('bruxelles_date')}</strong>
//           </p>

//           {/* Description */}
//           <p style={{
//             color: '#6B7280',
//             fontSize: '14px',
//             textAlign: 'center',
//             marginBottom: '24px',
//             lineHeight: '1.6'
//           }}>
//             {t('bruxelles_quest')}
//             <br />
//            {t('bruxelles_ans')}
//           </p>

//           {/* CTA Button */}
//           <button 
//             style={{
//               width: '100%',
//               background: 'linear-gradient(40deg, #EE6FBB, #EC4899)',
//               color: 'white',
//               fontWeight: '600',
//               padding: '12px 24px',
//               borderRadius: '8px',
//               border: 'none',
//               cursor: 'pointer',
//               boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
//               transition: 'all 0.3s ease',
//               fontSize: '16px'
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.transform = 'scale(1.05)';
//               e.target.style.background = 'linear-gradient(40deg, #EC4899, #DB2777)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.transform = 'scale(1)';
//               e.target.style.background = 'linear-gradient(40deg, #EE6FBB, #EC4899)';
//             }}
//             onClick={() => {
            
//               window.location.href = t('bruxelles_link');
//               onClose();
//             }}
//           >
//             {t('bruxelles_reg')}
//           </button>
//         </div>
//       </div>
//       </div>
    
//   );
// };



  const featureListData = [
    {
      iconSrc: '/images/home_1/compassion.svg',
      title: t('feature1_title'),
      subTitle: t('feature1_subtitle'),
    },
    {
      iconSrc: '/images/home_1/excellence.svg',
      title: t('feature2_title'),
      subTitle: t('feature2_subtitle'),
    },
    {
      iconSrc: '/images/home_1/integrity.svg',
      title: t('feature3_title'),
      subTitle: t('feature3_subtitle'),
    },
    {
      iconSrc: '/images/home_1/respect.svg',
      title: t('feature4_title'),
      subTitle: t('feature4_subtitle'),
    },
    {
      iconSrc: '/images/home_1/teamwork.svg',
      title: t('feature5_title'),
      subTitle: t('feature5_subtitle'),
    },
  ];

  const faqData = [
    {
      title: t('faq1_title'),
      content: t('faq1_content'),
    },
    {
      title: t('faq2_title'),
      content: t('faq2_content'),
    },
    {
      title: t('faq3_title'),
      content: t('faq3_content'),
    },
    {
      title: t('faq4_title'),
      content: t('faq4_content'),
    },
    {
      title: t('faq5_title'),
      content: t('faq5_content'),
    },
  ];

  const awardData = [
    {
      title: t('award1_title'),
      subTitle: t('award1_subtitle'),
      iconUrl: '/images/icons/check-badge-svgrepo-com.svg',
    },
    {
      title: t('award2_title'),
      subTitle: t('award2_subtitle'),
      iconUrl: '/images/icons/check-badge-svgrepo-com.svg',
    },
    {
      title: t('award3_title'),
      subTitle: t('award3_subtitle'),
      iconUrl: '/images/icons/check-badge-svgrepo-com.svg',
    },
    {
      title: t('award4_title'),
      subTitle: t('award4_subtitle'),
      iconUrl: '/images/icons/check-badge-svgrepo-com.svg',
    },
  ];

  const departmentData = [
    {
      title: t('department1_title'),
      iconUrl: '/images/departments/hetero_opt_u.webp',
      href: t('department1_link', '/'),
    },
    {
      title: t('department2_title'),
      iconUrl: '/images/departments/lgtbiq_opt.webp',
      href: t('department2_link', '/'),
    },
    {
      title: t('department3_title'),
      iconUrl: '/images/departments/solteros_opt_u.webp',
      href: t('department3_link', '/'),
    },
    {
      title: t('department4_title'),
      iconUrl: '/images/departments/solteras_opt_u.webp',
      href: t('department4_link', '/'),
    },
    {
      title: t('department5_title'),
      iconUrl: '/images/departments/hiv_opt_u.webp',
      href: t('department5_link', '/'),
    },
    {
      title: t('department6_title'),
      iconUrl: '/images/departments/precio_uu_opt.webp',
      href: t('department6_link', '/'),
    },
  ];

  //  const { shouldShow, setShouldShow } = usePopupTrigger(); // Agregar esta línea

  // const handleClosePopup = () => {
  //   setShouldShow(false);
  // };


  // Always mount Hero; render rest when translations ready
  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={`${baseUrl}/images/home_1/Carrusel_Home.webp`} />
        <link rel="preload" as="image" href={`${baseUrl}/images/home_1/familia_gestacion_opt_movil.webp`} />
        <link rel="preload" as="image" href={`${baseUrl}/images/home_1/familia_gestacion_opt_u.webp`} />
        <link rel="preload" as="image" href={`${baseUrl}/images/contact/icon_1.svg`} />
        <link rel="preload" as="image" href={`${baseUrl}/images/whatsapp-svgrepo-com.svg`} />
        <link rel="preload" as="image" href={`${baseUrl}/images/email-icon.svg`} />
        <title>{t('home_title')}</title>
        <meta name="description" content={t('meta_description')} />
        {/* Etiqueta canonical dinámica */}
        <link
          rel="canonical"
          href={`https://www.gestlifesurrogacy.com/${i18n.language !== 'es' ? i18n.language + '/' : ''}`}
        />
      </Helmet>

      <Hero
        title={t('welcome')}
        subTitle={t('subtitle')}
        titleTwo={t('titleTwo')}
        bgColor="linear-gradient(40deg, #EE6FBB, #7BADD3)"
        imgUrl="/images/home_1/familia_gestacion_opt_u.webp"
        imgUrlMobile="/images/home_1/familia_gestacion_opt_movil.webp"
        videoBtnText={t('who_we_are')}
        videoUrl={t('video_who_we_are')}
        infoList={[
          {
            title: t('phone'),
            titleTwo: t('free_call'),
            subTitle: '+302112340748',
            iconUrl: '/images/contact/icon_1.svg',
            link: 'tel:+302112340748',
          },
          {
            title: t('whatsapp'),
            subTitle: '+302112340748',
            iconUrl: '/images/whatsapp-svgrepo-com.svg',
            link: 'https://api.whatsapp.com/send?phone=302112340748',
          },
          {
            title: t('phone_two'),
            subTitle: '+13054041866',
            iconUrl: '/images/contact/icon_1.svg',
            link: 'tel:+13054041866',
          },
          {
            title: t('email'),
            subTitle: 'info@gestlifesurrogacy.com',
            iconUrl: '/images/email-icon.svg',
            link: 'mailto:info@gestlifesurrogacy.com',
          },
        ]}
        btnText={t('contact_us')}
        btnUrl={t('contact_us_link', '/')}
      />

      {/* Contenido diferido sección-a-sección con LazySection */}
      {ready && (
        <>
          {/* Feature Section */}
          <LazySection>
            <Section
              topMd={200}
              topLg={10}
              topXl={120}
              bottomMd={185}
              bottomLg={60}
              bottomXl={100}
            >
              {/* <AssistedReproductionSection /> */}
              <FeaturesSection
                sectionTitle={t('features_section_title')}
                data={featureListData}
              />
            </Section>
          </LazySection>

          {/* About Section */}
          <LazySection>
            <Section>
              <AboutSection
                imgUrl="/images/home_1/Gestlife_team2.webp"
                spiningImgUrl="/images/home_1/about_mini.svg"
                title={t('about_section_title')}
                subTitle={t('about_section_subtitle')}
                featureList={[
                  {
                    featureListTitle: t('about_feature_list_title'),
                    featureListSubTitle: t('read_more'),
                  },
                ]}
                linkTo={t('warranties_link', '/')}
              />
            </Section>
          </LazySection>

          {/* Departments Section */}
          <LazySection>
            <Section topMd={185} topLg={60} topXl={50}>
              <DepartmentSection
                sectionTitle={t('programs_section_title')}
                bgColor="linear-gradient(40deg, #EE6FBB, #7BADD3)"
                data={departmentData}
              />
            </Section>
          </LazySection>

          {/* Conferences Section */}
          <LazySection>
            <Section topMd={80} topLg={40} topXl={60}>
              <ConferencesSection
                imgUrl="/images/home_1/conferencias_opt.webp"
                spiningImgUrl="/images/home_1/about_mini.svg"
                title={t('conferences_section_title')}
                subTitle={t('conferences_section_subtitle')}
                featureList={[
                  {
                    featureListTitle: t('conferences_feature_list_title'),
                    featureListSubTitle: t('read_more'),
                  },
                ]}
                linkTo={t('conferences_link')}
              />
            </Section>
          </LazySection>

          {/* Award Section */}
          <LazySection>
            <Section topMd={185} topLg={60} topXl={100}>
              <AwardSection
                sectionTitle={t('award_section_title')}
                data={awardData}
              />
            </Section>
          </LazySection>

          {/* Testimonial Section */}
          <LazySection>
            <Section
              topMd={185}
              topLg={60}
              topXl={100}
              bottomMd={200}
              bottomLg={60}
              bottomXl={110}
            >
              <TestimonialSection
                sectionTitle={t('testimonial_section_title')}
                sectionTitleDown={t('testimonial_section_subtitle')}
              />
            </Section>
          </LazySection>

          {/* Banner Section */}
          <LazySection>
            <Section>
              <Banner
                bgColor="linear-gradient(40deg, #EE6FBB, #7BADD3)"
                imgUrl="/images/home_1/familia_gestacion (1).webp"
                title={t('banner_section_title')}
                subTitle={t('banner_section_subtitle')}
                linkTo="/blog/en-que-consiste-gestacion-subrogada/"
                linkWord={t('learn_more', '/')}
              />
            </Section>
          </LazySection>

          {/* FAQ Section */}
          <LazySection>
            <Section topMd={190} topLg={60} topXl={80}>
              <FaqSection
                data={faqData}
                sectionTitle={t('faq_section_title')}
                sectionTitleUp={t('faq_section_subtitle')}
              />
            </Section>
          </LazySection>

          {/* Banner2 Section */}
          <LazySection>
            <Section bottomMd={60} topLg={60} topXl={80}>
              <Banner2
                bgColor="linear-gradient(40deg, #EE6FBB, #7BADD3)"
                imgUrl="/images/home_1/madre_optimizada.webp"
                title={t('mother_in_surrogacy_title')}
                subTitle={t('mother_in_surrogacy_subtitle')}
                linkTo="/blog/la-madre-en-una-gestacion-subrogada/"
                linkWord={t('learn_more', '/')}
              />
            </Section>
          </LazySection>

          {/* Métodos de Contacto */}
          <div style={{ visibility: showContactMethods ? 'visible' : 'hidden' }}>
            <ContactMethods />
          </div>
        </>
      )}
        {/* <WishForBabyPopup 
        isOpen={shouldShow} 
        onClose={handleClosePopup}
      /> */}
    </>
  );
}
